const colorPicker = {
    add: 'WYBIERZ',
    change: 'ZMIEŃ',
    close: 'WRÓĆ'
};

export default colorPicker;